/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import useGroupBookingCounter from "../hooks/useGroupBookingCounter";
import Icon from "./ui/Icon";
import Button from "./ui/Button";
import Text from "./ui/Text";
import styled from "styled-components";
import { useTranslate } from "../hooks/useTranslate";

const StyledCounter = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const GroupBookingCounterView = ({ counter, canDecrease, canIncrease, onDecrease, onIncrease }) => {
  const { _t } = useTranslate();
  const handleMouseDown = (e) => {
    e.preventDefault();
    e.currentTarget.blur();
  };

  return (
    <StyledCounter onClick={(e) => e.stopPropagation()}>
      <Icon.Users color="secondary" />
      <Button variant="transparent" size="icon"
        disabled={!canDecrease} onClick={onDecrease}
        icon={<Icon.ChevronLeft />}
        onMouseDown={handleMouseDown}
        aria-label={_t("Decrease group size")}
      />
      <Text size="large" color="dark">{counter}</Text>
      <Button variant="transparent" size="icon"
        disabled={!canIncrease}
        onClick={onIncrease}
        icon={<Icon.ChevronRight />}
        onMouseDown={handleMouseDown}
        aria-label={_t("Increase group size")}
      />
    </StyledCounter>
  );
};

export const GroupBookingCounter = ({ service, category }) => {
  const { counter, disabled, maxCounter, handleIncrease, handleDecrease } = useGroupBookingCounter({ service, category });

  return (
    <GroupBookingCounterView
      counter={counter}
      canDecrease={!disabled && counter !== (service.min_group_booking || 1)}
      canIncrease={!disabled && counter < maxCounter}
      onDecrease={handleDecrease}
      onIncrease={handleIncrease}
    />
  );
};
